import React from 'react';
import { Card, Typography } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { KPIMetric } from './demoData';

const { Text } = Typography;

interface KPIMetricsProps {
  data: KPIMetric[];
}

const KPIMetrics: React.FC<KPIMetricsProps> = ({ data }) => {
  const getTrendIcon = (changeType: 'up' | 'down') => {
    return changeType === 'up' ? (
      <ArrowUpOutlined className="text-green-500" />
    ) : (
      <ArrowDownOutlined className="text-red-500" />
    );
  };

  const getComparisonColor = (changeType: 'up' | 'down') => {
    return changeType === 'up' ? 'text-green-600' : 'text-red-600';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {data.map((metric, index) => (
        <Card
          key={index}
          className="shadow-sm border-0 bg-white rounded-lg"
          styles={{ body: { padding: '20px' } }}
        >
          <div className="flex flex-col space-y-2">
            <div className="flex items-center justify-between">
              <Text className="text-gray-600 text-sm font-medium">
                {metric?.title}
              </Text>
              {getTrendIcon(metric?.changeType)}
            </div>
            <div className="flex items-baseline space-x-2">
              <Text className="text-2xl font-bold text-gray-900">
                {metric?.value}
              </Text>
              <Text
                className={`text-sm font-medium ${getComparisonColor(metric?.changeType)}`}
              >
                {metric?.change}
              </Text>
            </div>
            <Text className="text-xs text-gray-500">{metric?.subLabel}</Text>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default KPIMetrics;
